import React from "react";
import {connect} from "react-redux";
import {Stack} from "@mui/material";
import "../openseadragon/styles.css";

/** OpenLayers draws its own ScaleLine control; under OpenSeadragon this one is shown instead. */
const ScaleBarOSD = ({slidemap, scaleText, scaleBarWidth}) => {
	if (!slidemap?._isOpenSeadragon || !scaleText || !scaleBarWidth) return null;
	return (
		<Stack className="osd-scale-bar-pro">
			<div className="osd-scale-bar-pro__ruler">
				<div className="osd-scale-bar-pro__cap"/>
				<div className="osd-scale-bar-pro__line" style={{width: `${scaleBarWidth}px`}}/>
				<div className="osd-scale-bar-pro__cap"/>
			</div>
			<span className="osd-scale-bar-pro__label">{scaleText}</span>
		</Stack>
	);
};

const mapStateToProps = (state) => {
	const {slidemap, scaleText, scaleBarWidth} = state.mapsStateReducer[state.gammaStateReducer.activeMapId] || {};
	return {slidemap, scaleText, scaleBarWidth};
};

export default connect(mapStateToProps)(ScaleBarOSD);
